var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChAdeMoConnector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 12,
    r: 10.5,
    stroke: "param(outline) #000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 12,
    r: 7.5,
    stroke: "param(outline) #000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 16,
    r: 2,
    fill: "param(outline) #000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 8,
    r: 2,
    fill: "param(outline) #000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33331,
    cy: 12,
    r: 2,
    fill: "param(outline) #000"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 12,
    r: 2,
    fill: "param(outline) #000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChAdeMoConnector);
export default __webpack_public_path__ + "static/media/CHAdeMO_connector.99eba287cdb304e18c36718bb8ee7d4f.svg";
export { ForwardRef as ReactComponent };